import React, { useState } from "react";
import { rewardDataStyle as styles } from "../redeemRewards.tailwind";
import Button from "../../../../shared/Button/Button";
import { claimReward } from "../../../../../redux/slices/rewardSlice";
import { connect, useSelector } from "react-redux";
// import no_limit from '../../../../../assets/svgs/no_limit.svg'
import { getRemainingPoints, NO_LIMIT_REWARD_TEXT } from "./rewards.data";
import ConfirmClaimModal from "../../../../shared/Modals/ConfirmClaimModal/ConfirmClaimModal";
import RewardGaugeChart from "./RewardGaugeChart";

const RewardsData = ({ seasonId, reward, claimRewards, index, setClaimingRewardId, isClaimingCurrent, toggleRewardsView }) => {
  const { userPointsAndRewards, claimingReward, } = useSelector((state) => state.reward);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { rewardTitle: title, _id: rewardId, pointsValue: pointsPrice } = reward;
  const remainingPointsToClaim = (pointsPrice - userPointsAndRewards?.userTotalAvailablePoints) > 0 ? pointsPrice - userPointsAndRewards?.userTotalAvailablePoints : 0
  const earnedPoints = pointsPrice - remainingPointsToClaim;   
  const percentage = Math.min((earnedPoints / pointsPrice) * 100, 100)?.toFixed(0);  // Percentage
  const remainingRewards = getRemainingPoints(reward);

  const handleClaim = async () => {
    setClaimingRewardId(index);
    if (seasonId && rewardId) {
      const response = await claimRewards({ seasonId, rewardId });
      if(claimReward.fulfilled.match(response)){ 
        toggleRewardsView();
      }
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <div className={styles.outerContainer}>       
        {/* Left Section - Reward Information */}
        <div className={styles.topContainer}>
          <div className={styles.rewardDescription}>
            {/* Title */}
            <span className={styles.heading}>{title}</span>

            {/* Earn-remaining-points */}
            <span className={`${styles.subHeading}`}>
                {remainingPointsToClaim > 0 
                  ? `Earn ${remainingPointsToClaim} More To Get This Reward` 
                  : <span><span className={styles.clickableText} onClick={() => setIsModalOpen(true)}>Click Here</span> To Get This Reward</span>}
            </span>
          </div>

          <div className={styles.imageContainer}>
            {/* Reward Image/ Icon/ Logo */}
            <img src={reward?.rewardIcon} alt={title} className={styles.rewardImage} />
          </div>
          
          {/* <div className={styles.rewardDetails}> */}

            {/* Total Points */}
            {/* <div className={styles.pointsPrice}>
              Total Cost - {pointsPrice} Points
            </div> */}
          {/* </div> */}

            {/* <div className="w-full h-auto">
              <RewardGaugeChart />
            </div> */}

            {/* <div className={styles.ribbonContainer}>
              <span className={styles.ribbonText}>{remainingRewards === NO_LIMIT_REWARD_TEXT ? 'No Limit' : (remainingRewards + " Left")}</span>
            </div> */}
        </div>

        {/* Right Section - Divider and Remaining */}
        <div className={styles.bottomContainer}>
          <RewardGaugeChart progress={percentage} totalPoints={pointsPrice} />

          {/* Remaining Points */}
          <div className={styles.remainingDetails}>
            <div className={styles.remainingDetailsHidden}>
              <div className={styles.remainingdiv}>
                {/* {remainingRewards === NO_LIMIT_REWARD_TEXT && (
                  <img src={no_limit} alt="no_limit" className="max-w-[40px]" />
                )} */}
                <span className="whitespace-nowrap" >{remainingRewards}</span>
                <span className={styles.badge_span}></span>
              </div>
              {remainingRewards !== NO_LIMIT_REWARD_TEXT && <span>Remaining</span>}
          </div>
            
            {/* button to claim reward */}
            <Button
              variant={percentage === "100" ? "redeem" : "secondary"}
              className={styles.button}
              // onClick={handleClaim}
              onClick={() => setIsModalOpen(true)}
              disabled={(claimingReward && isClaimingCurrent) || percentage !== "100"}
            >
              {percentage === "100" ? "Redeem Now" :  "Redeem"}
              {/* {(claimingReward && isClaimingCurrent) ? `Claiming...` : `Claim Now`} */}
            </Button>
          </div>
        </div>

        {isModalOpen &&
          <ConfirmClaimModal onClose={handleModalClose} onClaim={handleClaim}  isOpen={isModalOpen}  reward={reward}/>
        }
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  claimRewards: (data) => dispatch(claimReward(data)),
});

export default connect(null, mapDispatchToProps)(RewardsData);
